jQuery(document).ready(function () {
    $('.dnScrollToMore').each(function () {
        var object = $(this);

        var container = $(object.attr('data-container'));

        var menuTop = object.find('.dnScrollToMore-link-top');
        var menuBottom = object.find('.dnScrollToMore-link-bottom');
        var visibleClass = 'dnScrollToMore-link-visible';

        var checkVisibility = function() {
            var scrollTop = container[0].scrollTop;
            var clientHeight = container[0].clientHeight;
            var scrollHeight = container[0].scrollHeight;
            var visibleDistance = 50;

            // check visibility scrollTop
            if (scrollTop > visibleDistance) {
                menuTop.addClass(visibleClass);
            } else {
                menuTop.removeClass(visibleClass);
            }

            // check visibility scrollBottom
            if (clientHeight + scrollTop < scrollHeight - visibleDistance) {
                menuBottom.addClass(visibleClass);
            } else {
                menuBottom.removeClass(visibleClass);
            }
        };

        container.scroll(function() {
            checkVisibility();
        });

        window.addEventListener('resize', function(){
            checkVisibility();
        });

        checkVisibility();
    });
});

jQuery(document).ready(function () {
    $(document).on('click', '.dnScrollToMore-link', function (e) {
        e.preventDefault();

        var container = $($(this).parent().attr('data-container'));
        var scrollTo = 0;

        if ($(this).hasClass('dnScrollToMore-link-bottom')) {
            scrollTo = container[0].scrollHeight - container[0].clientHeight;
        }
        container.animate({scrollTop:scrollTo}, 300, 'swing');
    });
});
